<template>
  <div>
    <NuxtRouteAnnouncer/>
    <NuxtLoadingIndicator :color="brandColor"  />
    <NuxtLayout>
        <NuxtPage />
    </NuxtLayout>
  </div>
</template>
<script setup lang="ts">
const ga4id = useRuntimeConfig().public.analytics.google.ga4;
const brandColor = useRuntimeConfig().public.colors.brand;

useHead({
    script: import.meta.dev ? [] : [
        {
            src: `https://www.googletagmanager.com/gtag/js?id=${ga4id}`,
            async: true,
        },
        {
            innerHTML() {
                return `window.dataLayer = window.dataLayer || [];`
            },
        },
        {
            src: "https://identity.netlify.com/v1/netlify-identity-widget.js",
            async: true
        },
    ],
});
</script>

<style>
.page-enter-active,
.page-leave-active {
    transition: opacity 0.2s;
}
.page-enter-from,
.page-leave-to {
    opacity: 0;
}
</style>